import React from "react";
import './index.css'
import Popup, {PopupMessage} from "../Popup";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const infoSvgPath: string = require("./info.svg");
const defaultPosition = {top: 0}
type InfoPosition = {
    top: number;
}

type InfoProps = {
    position?: InfoPosition;
    isOpen: boolean;
    id: string;
    details: PopupMessage;
    handleOpen: () => void;
    handleClose: () => void;
}


const Info = ({position = defaultPosition, isOpen, id, details, handleOpen, handleClose}: InfoProps) => {
    const resolveInfoImageClassName = () => {
        return `info-image ${(isOpen ? "info-clicked" : "info-not-clicked")}`
    }

    return (
        <>
            <div className="visible-only-to-screen-reader">The meaning of {details.header}: {details.body}</div>
            <a data-testid={id + "_infoAnchor"} target="_self" className="info-container info-anchor"
               key={id + "_infoAnchor"} aria-label="">
                {isOpen && <Popup message={details} handlePopupClose={handleClose}/>}
                <img key={id + "_infoImg"}
                     data-testid={id + "_infoImg"}
                     onClick={handleOpen}
                     className={resolveInfoImageClassName()}
                     src={infoSvgPath}
                     alt=""
                     style={{top: position.top}}
                />
            </a>
        </>
    );
};

export default Info;